import {
  BlankSlate,
  BlankSlateDescription,
  BlankSlateIcon,
  BlankSlateTitle,
  Box
} from "@prismicio/editor-ui"

export function EmptyMediaList() {
  return (
    <Box
      justifyContent="center"
      flexDirection="column"
      height="100%"
      backgroundColor="grey3"
    >
      <BlankSlate>
        <BlankSlateIcon
          name="close"
          lineColor="purple10"
          backgroundColor="purple3"
          borderColor="purple6"
          borderStyle="dashed"
          size="xlarge"
        />
        <BlankSlateTitle size="big">"Oops!"</BlankSlateTitle>
        <BlankSlateDescription width={360}>
          "We can't find any items with that name"
        </BlankSlateDescription>
      </BlankSlate>
    </Box>
  )
}
